<template>

    <v-modal title="Test Template">
        <template #body>
            <v-alert :message="error" />
            <p class="small mb-20">Enter an email address to send a test.<br>Separate multiple email addresses with a comma.</p>
            <form @submit.prevent="testTemplate">
                <v-input placeholder="name@mydomain.com" :model="params.recipient" @input="params.recipient = $event" />
                <v-checkbox class="mt-15" label="Personalize with a customer" :model="params.personalize" @input="params.personalize = $event" />
            </form>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" btn-style="success" :loading="loading" @click.native="testTemplate">Send</v-button>
        </template>
    </v-modal>

</template>

<script>

import TemplateApi from '@api/TemplateApi';

export default {

    props: {
        template: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            error: null,
            params: {
                personalize: true,
            },
        }
    },

    methods: {

        testTemplate() {
            this.loading = true;
            TemplateApi.testTemplate(this.template.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.sent'));
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
